import React from "react";

import { Box, Typography } from "@mui/material";

import { Para16Text } from "components/shared/Typography";

export interface ITransferInfoLineProps {
  label: string;
  infoText: string | React.ReactNode;
}

export const TransferInfoLine: React.FC<ITransferInfoLineProps> = ({
  label,
  infoText,
}) => {
  return (
    <Box display="flex" columnGap={1}>
      <Typography variant="h5" component="h3">
        {label}
      </Typography>
      <Para16Text>{infoText}</Para16Text>
    </Box>
  );
};
